export const GA_CATEGORIES = {
  SEARCH: 'search',
}
